import { OlbyNetworkIcon, OlbyNetworkIconMd, OlbyNetworkIconSm } from '@icons'
import classnames from 'classnames'
import { forwardRef } from 'react'

import CTAButton from '../button'

import styles from './styles.module.scss'

export const HireOlbySection = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['hire-olby-section-container']} ref={ref}>
      <div className={styles['hire-olby-section-wrapper']}>
        <OlbyNetworkIcon
          className={classnames(styles['olby-network-icon'], styles['default-icon'])}
        />
        <OlbyNetworkIconMd
          className={classnames(styles['olby-network-icon'], styles['medium-icon'])}
        />
        <OlbyNetworkIconSm
          className={classnames(styles['olby-network-icon'], styles['small-icon'])}
        />

        <div className={styles['content']}>
          <h2 className={styles['section-title']}>
            Engaging tech talent for trustworthy companies.
          </h2>
          <CTAButton
            href="/companies"
            variant="secondary"
            className={styles['button']}
            prefetch={false}
          >
            hire Olby
          </CTAButton>
        </div>
      </div>
    </section>
  )
})

export default HireOlbySection
